import { GetTipoContattoQuery } from '../../_graphql/generated';

export type TipoContattoState = {
  loading: boolean;
  lista: GetTipoContattoQuery['anagrafica_tipo_contatto'];
  failure: any;
};

export const initialTipoContattoState: TipoContattoState = {
  loading: false,
  lista: [],
  failure: '',
};
